/* BACTO theme — minimal JS */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* Mobile menu toggle */
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-menu]');

  if (toggle && nav) {
    /* The labels come from the language files via the button itself, so the
       toggle reads "Menü" / "Schließen" in German and "Menu" / "Close" in
       English. Escape or a tap outside closes it and hands focus back. */
    var setMenu = function (open) {
      nav.setAttribute('data-open', open ? 'true' : 'false');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = toggle.getAttribute(open ? 'data-label-close' : 'data-label-open');
    };

    toggle.addEventListener('click', function () {
      setMenu(nav.getAttribute('data-open') !== 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('data-open') === 'true') {
        setMenu(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (nav.getAttribute('data-open') === 'true' && !nav.contains(e.target)) setMenu(false);
    });
  }




  /* ------------------------------------------------------------------
     Bundle deal — choosing between products, picking a size, and keeping
     the totals honest while the customer switches.

     Liquid has already printed a correct, complete bundle for the default
     selection, hidden inputs included. This only takes over once a choice
     is made, so the section works with the script blocked: one product and
     one size per slot, exactly what was rendered.
     ------------------------------------------------------------------ */
  var formatMoney = function (cents, format) {
    var value = (cents || 0) / 100;

    /* Shopify's money format may carry markup — merchants wrap the amount
       in a span often enough. This lands in textContent, so any tags would
       show up as literal angle brackets in the totals. */
    format = String(format).replace(/<[^>]*>/g, '');

    var withSeparators = function (decimals, thousands, decimalMark) {
      var fixed = value.toFixed(decimals);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? whole + decimalMark + parts[1] : whole;
    };

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount_no_decimals':                      return withSeparators(0, ',', '.');
        case 'amount_with_comma_separator':             return withSeparators(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSeparators(0, '.', ',');
        case 'amount_with_apostrophe_separator':        return withSeparators(2, "'", '.');
        default:                                        return withSeparators(2, ',', '.');
      }
    });
  };

  var setupBundle = function (root) {
    var pct    = parseInt(root.getAttribute('data-bundle-pct'), 10) || 0;
    var scope  = root.getAttribute('data-bundle-scope') || 'total';
    var format = root.getAttribute('data-money-format') || '{{amount}}';

    var money = function (cents) { return formatMoney(cents, format); };

    var totalRegular = root.querySelector('[data-total-regular]');
    var totalBundle  = root.querySelector('[data-total-bundle]');
    var totalSaving  = root.querySelector('[data-total-saving]');
    var form         = root.querySelector('[data-bundle-form]');
    var submit       = form ? form.querySelector('button[type="submit"]') : null;

    var slots = [];

    Array.prototype.forEach.call(root.querySelectorAll('[data-slot]'), function (el) {
      var json = el.querySelector('[data-slot-json]');
      if (!json) return;

      var data;
      try { data = JSON.parse(json.textContent); } catch (e) { return; }
      if (!data.products || !data.products.length) return;

      var slot = {
        el: el,
        products: data.products,
        chosen: data.products[0],
        variant: null,
        priceEl: el.querySelector('[data-slot-price]'),
        select: el.querySelector('[data-slot-variant]'),
        sizeBox: el.querySelector('.bundle__size'),
        sizeLabel: el.querySelector('.bundle__size-label')
      };
      slot.variant = pickVariant(slot.chosen, null);
      slots.push(slot);

      Array.prototype.forEach.call(el.querySelectorAll('[data-switch]'), function (button) {
        button.addEventListener('click', function () {
          choose(slot, button.getAttribute('data-switch'));
        });
      });

      if (slot.select) {
        slot.select.addEventListener('change', function () {
          slot.variant = byId(slot.chosen, slot.select.value) || slot.variant;
          render();
        });
      }
    });

    if (!slots.length) return;

    function byId(product, id) {
      var found = null;
      product.variants.forEach(function (v) {
        if (String(v.id) === String(id)) found = v;
      });
      return found;
    }

    /* Keep the size across a product switch where it exists — someone who
       picked L for one jacket means L for the other. Otherwise fall to the
       first size actually in stock. */
    function pickVariant(product, keepTitle) {
      var match = null;
      if (keepTitle) {
        product.variants.forEach(function (v) {
          if (!match && v.title === keepTitle && v.available) match = v;
        });
      }
      if (!match) {
        product.variants.forEach(function (v) {
          if (!match && v.available) match = v;
        });
      }
      return match || product.variants[0] || null;
    }

    function choose(slot, productId) {
      var next = null;
      slot.products.forEach(function (p) {
        if (String(p.id) === String(productId)) next = p;
      });
      if (!next || next === slot.chosen) return;

      var keep = slot.variant ? slot.variant.title : null;
      slot.chosen = next;
      slot.variant = pickVariant(next, keep);
      render();
    }

    function renderSlot(slot) {
      Array.prototype.forEach.call(slot.el.querySelectorAll('[data-option]'), function (tile) {
        var on = String(tile.getAttribute('data-option')) === String(slot.chosen.id);
        tile.classList.toggle('is-hidden', !on);
        tile.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      Array.prototype.forEach.call(slot.el.querySelectorAll('[data-switch]'), function (button) {
        var on = String(button.getAttribute('data-switch')) === String(slot.chosen.id);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      if (slot.select) {
        var single = slot.chosen.hasOneVariant || slot.chosen.variants.length < 2;
        if (slot.sizeBox) slot.sizeBox.hidden = single;
        if (slot.sizeLabel) slot.sizeLabel.textContent = slot.chosen.optionName || '';

        slot.select.innerHTML = '';
        slot.chosen.variants.forEach(function (v) {
          var option = document.createElement('option');
          option.value = v.id;
          option.textContent = v.title;
          option.disabled = !v.available;
          if (slot.variant && v.id === slot.variant.id) option.selected = true;
          slot.select.appendChild(option);
        });
      }

      if (slot.priceEl && slot.variant) {
        slot.priceEl.textContent = money(slot.variant.price);
      }
    }

    function render() {
      var regular = 0;
      var cheapest = 0;
      var sellable = true;

      slots.forEach(function (slot) {
        renderSlot(slot);
        if (!slot.variant) { sellable = false; return; }
        if (!slot.variant.available) sellable = false;
        regular += slot.variant.price;
        if (!cheapest || slot.variant.price < cheapest) cheapest = slot.variant.price;
      });

      var base = scope === 'cheapest' ? cheapest : regular;
      var saving = Math.round(base * pct / 100);

      if (totalRegular) totalRegular.textContent = money(regular);
      if (totalBundle)  totalBundle.textContent  = money(regular - saving);
      if (totalSaving)  totalSaving.textContent  = money(saving);

      if (form) {
        slots.forEach(function (slot, i) {
          var input = form.querySelector('[data-line="' + i + '"]');
          if (input && slot.variant) input.value = slot.variant.id;
        });
      }

      if (submit) submit.disabled = !sellable;
    }

    render();
  };

  Array.prototype.forEach.call(document.querySelectorAll('[data-bundle]'), setupBundle);

  /* ------------------------------------------------------------------
     The footer "Cookie-Einstellungen" link. With our own banner switched
     off, it opens Shopify's cookie banner preferences (Customer Privacy:
     window.privacyBanner.showPreferences), so consent can be withdrawn as
     easily as it was given (DSGVO Art. 7 Abs. 3). Shopify loads that
     banner itself; the link is only hidden when, after the page has
     loaded, neither banner is there.
     ------------------------------------------------------------------ */
  if (!document.getElementById('CookieBanner')) {
    var cookieLinks = document.querySelectorAll('[data-cookie-settings]');
    var shopifyPrefs = function () {
      return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    };
    Array.prototype.forEach.call(cookieLinks, function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (shopifyPrefs()) window.privacyBanner.showPreferences();
      });
    });
    window.addEventListener('load', function () {
      setTimeout(function () {
        if (shopifyPrefs()) return;
        Array.prototype.forEach.call(cookieLinks, function (link) {
          var row = link.closest ? link.closest('li') : null;
          (row || link).hidden = true;
        });
      }, 3000);
    });
  }

  /* ------------------------------------------------------------------
     Footer columns as an accordion.

     Built as an enhancement rather than as markup: the page ships with
     every column open, and only a browser running this script folds them
     away. Without JavaScript the legal links stay visible, which is what
     § 5 ECG asks for — a fold that never opens would hide the Impressum.
     ------------------------------------------------------------------ */
  var cols = document.querySelector('[data-footer-accordion]');

  if (cols) {
    var mode = cols.getAttribute('data-footer-accordion') || 'always';
    var phone = window.matchMedia('(max-width: 749px)');
    var panels = [];

    Array.prototype.forEach.call(
      cols.querySelectorAll('[data-footer-heading]'),
      function (heading, i) {
        var panel = heading.parentNode.querySelector('[data-footer-panel]');
        if (!panel) return;

        /* The heading keeps its level; the button lives inside it, so the
           outline stays intact for screen readers. */
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'footer__toggle';
        button.innerHTML = heading.innerHTML;
        heading.innerHTML = '';
        heading.appendChild(button);

        panel.id = panel.id || 'FooterPanel' + i;
        button.setAttribute('aria-controls', panel.id);

        var setOpen = function (open) {
          panel.hidden = !open;
          button.setAttribute('aria-expanded', open ? 'true' : 'false');
        };

        button.addEventListener('click', function () {
          setOpen(button.getAttribute('aria-expanded') !== 'true');
        });

        panels.push(setOpen);
      }
    );

    /* "Only on phones" has to react to a window being resized across the
       breakpoint, otherwise a column folded on a narrow window stays folded
       when it widens again. */
    var apply = function () {
      var folded = mode === 'always' || (mode === 'mobile' && phone.matches);
      cols.setAttribute('data-folded', folded ? 'true' : 'false');
      panels.forEach(function (setOpen) { setOpen(!folded); });
    };

    apply();
    if (mode === 'mobile') {
      if (phone.addEventListener) phone.addEventListener('change', apply);
      else if (phone.addListener) phone.addListener(apply);
    }
  }

  /* ------------------------------------------------------------------
     Withdrawal form — two steps, as § 13a FAGG requires: fill in, then a
     separate screen whose only primary action is "Widerruf bestätigen".
     Runs for every .widerruf__form on the page (the footer dialog and, if
     present, the standalone page). Without JS the noscript button submits.
     ------------------------------------------------------------------ */
  var setupWiderruf = function (form) {
    var step1 = form.querySelector('[data-step="1"]');
    var step2 = form.querySelector('[data-step="2"]');
    var review = form.querySelector('[data-widerruf-review]');
    var next = form.querySelector('[data-widerruf-next]');
    var back = form.querySelector('[data-widerruf-back]');
    if (!step1 || !step2 || !next) return;

    var labelFor = function (field) {
      var l = form.querySelector('label[for="' + field.id + '"]');
      return l ? l.textContent.replace('*', '').trim() : field.name;
    };

    next.addEventListener('click', function () {
      var missing = null;
      Array.prototype.forEach.call(step1.querySelectorAll('[data-required]'), function (f) {
        var bad = !f.value.trim() || (f.type === 'email' && !f.checkValidity());
        if (bad && !missing) missing = f;
        if (bad) f.setAttribute('aria-invalid', 'true');
        else f.removeAttribute('aria-invalid');
      });
      if (missing) {
        if (missing.reportValidity) missing.reportValidity();
        missing.focus();
        return;
      }

      review.innerHTML = '';
      var fields = step1.querySelectorAll('input[name^="contact["], textarea[name^="contact["]');
      Array.prototype.forEach.call(fields, function (f) {
        if (f.type === 'hidden' || !f.value.trim()) return;
        var row = document.createElement('div');
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = labelFor(f);
        dd.textContent = f.value.trim();
        row.appendChild(dt); row.appendChild(dd);
        review.appendChild(row);
      });

      /* Stamp the moment of submission for the acknowledgement email. */
      var stamp = form.querySelector('[data-widerruf-stamp]') || document.getElementById('WiderrufStamp');
      var body = form.querySelector('[data-widerruf-body]') || document.getElementById('WiderrufBody');
      var now = new Date();
      if (stamp) stamp.value = now.toLocaleString('de-AT') + ' (' + now.toISOString() + ')';
      if (body) {
        var lines = ['Widerruf über die Rücktrittsfunktion der Website.'];
        Array.prototype.forEach.call(review.querySelectorAll('div'), function (row) {
          lines.push(row.querySelector('dt').textContent + ': ' + row.querySelector('dd').textContent);
        });
        lines.push('Abgesendet am: ' + (stamp ? stamp.value : ''));
        body.value = lines.join('\n');
      }

      step1.hidden = true;
      step2.hidden = false;
      step2.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    if (back) {
      back.addEventListener('click', function () {
        step2.hidden = true;
        step1.hidden = false;
        step1.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  };

  Array.prototype.forEach.call(document.querySelectorAll('.widerruf__form'), setupWiderruf);

  /* ------------------------------------------------------------------
     Product form.

     The select carries the variant id, so the cart is already correct
     without any of this. What this adds is the price beside the title
     following the selection, and the button refusing a size that is sold
     out — both rendered by Liquid up front, so nothing here has to know how
     money is written or what the button says in which language.

     No size chosen yet (the select stands on "Größe wählen"): the buttons
     — main button, buy bar, express — do not buy; tapped, they say
     "Bitte wähle eine Größe" and bring the size choice into view.
     ------------------------------------------------------------------ */
  Array.prototype.forEach.call(document.querySelectorAll('[data-product-form]'), function (form) {
    var select = form.querySelector('[data-variant-select]');
    var json = form.querySelector('[data-variant-json]');
    if (!select || !json) return;

    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (e) {
      return;
    }

    var priceEl = document.querySelector('[data-variant-price]');
    var button = form.querySelector('[data-variant-button]');
    var anyAvailable = variants.some(function (v) { return v.available; });
    var express = form.querySelector('[data-express-buttons]');
    var guard = form.querySelector('[data-size-guard]');

    /* Shown only while no size is chosen: express buttons shut, the clear
       layer over them answers a tap with the hint. */
    var lockExpress = function (locked) {
      if (express && 'inert' in express) express.inert = locked;
      if (express) express.classList.toggle('is-locked', locked);
      if (guard) guard.hidden = !locked;
    };

    var askForSize = function () {
      var hint = form.querySelector('[data-size-hint]');
      var pickers = form.querySelector('[data-size-pickers]');
      var target = pickers && !pickers.hidden ? pickers : select;
      if (hint) {
        hint.hidden = false;
        hint.textContent = '';
        hint.textContent = select.getAttribute('data-hint');
      }
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' });
      var first = null;
      if (target === pickers) {
        Array.prototype.some.call(pickers.querySelectorAll('[data-size-picker]'), function (row) {
          if (row.querySelector('input:checked')) return false;
          first = row.querySelector('input:not(:disabled)');
          return true;
        });
      } else {
        first = select;
      }
      if (first) first.focus({ preventScroll: true });
    };

    form.addEventListener('submit', function (e) {
      if (!select.value) {
        e.preventDefault();
        askForSize();
      }
    });
    if (guard) guard.addEventListener('click', askForSize);
    lockExpress(!select.value);

    select.addEventListener('change', function () {
      var id = select.value;
      var chosen = null;
      variants.forEach(function (v) {
        if (String(v.id) === String(id)) chosen = v;
      });
      lockExpress(!chosen);
      var hint = form.querySelector('[data-size-hint]');
      if (hint && chosen) hint.hidden = true;
      if (!chosen) {
        /* Back to "no size": buying waits for a choice again. */
        if (button) {
          button.disabled = !anyAvailable;
          button.textContent = anyAvailable ? button.getAttribute('data-label-add') : button.getAttribute('data-label-sold-out');
        }
        var emptyBar = document.querySelector('[data-buy-bar]');
        if (emptyBar) {
          var emptySize = emptyBar.querySelector('[data-buy-bar-size]');
          var emptyButton = emptyBar.querySelector('[data-buy-bar-button]');
          if (emptySize) emptySize.textContent = emptySize.getAttribute('data-placeholder');
          if (emptyButton && button) {
            emptyButton.disabled = button.disabled;
            emptyButton.textContent = button.textContent;
          }
        }
        return;
      }

      if (priceEl) priceEl.innerHTML = chosen.price;

      var qty = form.querySelector('[data-quantity]');
      if (qty) {
        if (chosen.max) {
          qty.max = chosen.max;
          if (parseInt(qty.value, 10) > chosen.max) qty.value = chosen.max;
        } else {
          qty.removeAttribute('max');
        }
      }

      if (button) {
        button.disabled = !chosen.available;
        button.textContent = chosen.available
          ? button.getAttribute('data-label-add')
          : button.getAttribute('data-label-sold-out');
      }

      /* The phone buy bar mirrors price, size and button state. */
      var bar = document.querySelector('[data-buy-bar]');
      if (bar) {
        var barPrice = bar.querySelector('[data-buy-bar-price]');
        var barSize = bar.querySelector('[data-buy-bar-size]');
        var barButton = bar.querySelector('[data-buy-bar-button]');
        if (barPrice) barPrice.textContent = chosen.money;
        if (barSize) barSize.textContent = chosen.title;
        if (barButton && button) {
          barButton.disabled = button.disabled;
          barButton.textContent = button.textContent;
        }
      }

      /* Keep the address in step, so a copied link opens on the same size. */
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  /* Run fn once the browser has a quiet moment (or right away where it
     cannot tell). requestIdleCallback must be called on window and takes
     an options object, never a number — a bare reference to it throws. */
  var whenIdle = function (fn) {
    if ('requestIdleCallback' in window) window.requestIdleCallback(fn);
    else window.setTimeout(fn, 1);
  };

  /* ------------------------------------------------------------------
     Product gallery.

     Below 900 px the pictures are a scroll-snap row; this only keeps the
     "1 / 4" under it in step. Every picture opens the large view: arrows,
     swipe and the arrow keys move through the set, Esc closes (the
     dialog's own behaviour) and focus returns to the picture.
     ------------------------------------------------------------------ */
  Array.prototype.forEach.call(document.querySelectorAll('[data-gallery]'), function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var current = gallery.querySelector('[data-gallery-current]');
    if (track && current) {
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = window.requestAnimationFrame(function () {
          tick = null;
          if (!track.clientWidth) return;
          current.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
        });
      }, { passive: true });
    }

    var box = gallery.querySelector('[data-lightbox]');
    var json = gallery.querySelector('[data-lightbox-json]');
    if (!box || !json || typeof box.showModal !== 'function') return;

    // The picture list is read on the first click, not while the page loads.
    var pictures = null;
    var list = function () {
      if (!pictures) { try { pictures = JSON.parse(json.textContent); } catch (e) { pictures = []; } }
      return pictures;
    };

    var img = box.querySelector('[data-lightbox-img]');
    var count = box.querySelector('[data-lightbox-current]');
    var index = 0;
    var opener = null;

    var show = function (i) {
      if (box.classList.contains('lightbox--single')) return;
      var all = list();
      if (!all.length) return;
      index = (i + all.length) % all.length;
      var p = all[index];
      img.srcset = p.srcset;
      img.src = p.src;
      img.width = p.width;
      img.height = p.height;
      img.alt = p.alt;
      if (count) count.textContent = index + 1;
    };

    Array.prototype.forEach.call(gallery.querySelectorAll('[data-lightbox-open]'), function (button) {
      button.addEventListener('click', function () {
        opener = button;
        box.classList.remove('lightbox--single');
        show(parseInt(button.getAttribute('data-lightbox-open'), 10) || 0);
        box.showModal();
      });
    });

    var prev = box.querySelector('[data-lightbox-prev]');
    var next = box.querySelector('[data-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    box.querySelector('[data-lightbox-close]').addEventListener('click', function () { box.close(); });

    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });

    var startX = null;
    box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      startX = null;
    });

    box.addEventListener('close', function () {
      box.classList.remove('lightbox--single');
      if (opener) opener.focus();
    });

    /* A single picture from elsewhere on the page (the size chart image):
       the same large view, without arrows or count. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-lightbox-single]'), function (button) {
      button.addEventListener('click', function () {
        opener = button;
        box.classList.add('lightbox--single');
        img.srcset = button.getAttribute('data-srcset');
        img.src = button.getAttribute('data-src');
        img.width = parseInt(button.getAttribute('data-width'), 10) || 1200;
        img.height = parseInt(button.getAttribute('data-height'), 10) || 1500;
        img.alt = button.getAttribute('data-alt') || '';
        box.showModal();
      });
    });
  });

  /* ------------------------------------------------------------------
     Product info column (desktop).

     It stays in view while the pictures scroll past. When it is taller
     than the window, it may not simply stick at the top — its lower part
     would never be reachable — so it sticks at the point where its bottom
     edge meets the bottom of the window instead.
     ------------------------------------------------------------------ */
  // Only where the column actually sticks (from 901 px); a phone skips the
  // measuring entirely. The first measurement waits for an idle moment.
  var wide = window.matchMedia ? window.matchMedia('(min-width: 901px)') : { matches: true };
  Array.prototype.forEach.call(document.querySelectorAll('[data-sticky-info]'), function (info) {
    var gap = 24;
    var fit = function () {
      if (!wide.matches) { info.style.top = ''; return; }
      var room = window.innerHeight - 2 * gap;
      info.style.top = (info.offsetHeight > room ? window.innerHeight - info.offsetHeight - gap : gap) + 'px';
    };
    whenIdle(fit);
    window.addEventListener('resize', fit);
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(info);
  });

  /* ------------------------------------------------------------------
     Size buttons (one row per option — two on a set).

     Nothing is chosen at first. Once every row has a choice, the variant
     is looked up and written into the `id` list, which then does
     everything it does on its own (price, button, quantity, buy bar);
     until then the list stays on "Größe wählen". Without this script the
     buttons stay hidden and the list is used as it is.

     A size that cannot be bought is struck through and cannot be chosen:
     in the first row when it is sold out in every combination, in the
     second row when it is sold out together with the size chosen in the
     first. Nothing jumps by itself: if a new choice in the first row
     makes the second one impossible, the second is simply cleared and
     the customer picks again.
     ------------------------------------------------------------------ */
  Array.prototype.forEach.call(document.querySelectorAll('[data-size-pickers]'), function (root) {
    var form = root.closest('form');
    var idSelect = form && form.querySelector('[data-variant-select]');
    var json = form && form.querySelector('[data-variant-json]');
    if (!idSelect || !json) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-size-picker]'));
    var inputsOf = function (row) { return Array.prototype.slice.call(row.querySelectorAll('input[type="radio"]')); };
    var button = form.querySelector('[data-variant-button]');
    var soldOut = button ? button.getAttribute('data-label-sold-out') : '';

    var find = function (values) {
      var hit = null;
      variants.forEach(function (v) {
        if (!hit && values.every(function (val, i) { return v.options[i] === val; })) hit = v;
      });
      return hit;
    };

    /* Can this value of this row still be bought, given the choices in the
       rows before it (a row without a choice yet allows anything)? */
    var canBuy = function (row, value, values) {
      return variants.some(function (v) {
        if (!v.available || v.options[row] !== value) return false;
        for (var k = 0; k < row; k++) if (values[k] !== null && v.options[k] !== values[k]) return false;
        return true;
      });
    };

    var refresh = function () {
      var values = rows.map(function (row) {
        var c = row.querySelector('input:checked');
        return c ? c.value : null;
      });
      rows.forEach(function (row, i) {
        inputsOf(row).forEach(function (input) {
          var ok = canBuy(i, input.value, values);
          input.disabled = !ok;
          input.parentNode.classList.toggle('is-sold-out', !ok);
          var state = input.parentNode.querySelector('[data-size-state]');
          if (state) state.textContent = ok ? '' : ' – ' + soldOut;
          if (!ok && input.checked) {
            input.checked = false;
            values[i] = null;
          }
        });
      });
      var complete = values.every(function (v) { return v !== null; });
      var chosen = complete ? find(values) : null;
      var next = chosen && chosen.available ? String(chosen.id) : '';
      if (String(idSelect.value) !== next) {
        idSelect.value = next;
        idSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };

    rows.forEach(function (row) {
      inputsOf(row).forEach(function (input) { input.addEventListener('change', refresh); });
    });
    root.hidden = false;
    /* The hidden list must not block the form with its own "required"
       message; the buttons and the hint take over. */
    idSelect.required = false;
    var fallback = form.querySelector('[data-variant-fallback]');
    if (fallback) fallback.hidden = true;
    refresh();
  });

  /* The line under the size buttons opens the restock form further down
     and puts the cursor in its size field. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-restock-open]'), function (link) {
    link.addEventListener('click', function (e) {
      var box = document.getElementById((link.getAttribute('href') || '').replace('#', ''));
      if (!box) return;
      e.preventDefault();
      box.open = true;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' });
      var field = box.querySelector('[data-restock-size]');
      if (field) field.focus({ preventScroll: true });
    });
  });

  /* ------------------------------------------------------------------
     Buy bar (phones).

     Shown while the main add-to-cart button is out of view — or, in the
     "after_button" mode, only once the visitor has scrolled past it. The
     bar submits the main form, so it always carries the chosen size.
     ------------------------------------------------------------------ */
  Array.prototype.forEach.call(document.querySelectorAll('[data-buy-bar]'), function (bar) {
    var main = document.querySelector('[data-buy-button]');
    if (!main || !('IntersectionObserver' in window)) return;

    var afterOnly = bar.getAttribute('data-mode') === 'after_button';
    bar.hidden = false;

    var show = function (on) {
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !on;
    };
    show(false);

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = e.boundingClientRect.bottom < 0;
      show(!e.isIntersecting && (!afterOnly || passed));
    }).observe(main);
  });

  /* ------------------------------------------------------------------
     Logo turn after load (header setting "Drehung startet nach dem Laden").

     The still frame is on screen from the first paint. Once the page has
     loaded, the turn is fetched in the background and swapped in only
     when it is complete, so the logo never goes blank. Reduced motion:
     nothing happens, the still stays.
     ------------------------------------------------------------------ */
  var turn = document.querySelector('[data-logo-turn]');
  if (turn && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
    var startTurn = function () {
      var source = turn.querySelector('source[data-turn]');
      var img = turn.querySelector('img[data-turn]');
      if (!img) return;
      var mobile = source && window.matchMedia(source.media).matches;
      var url = mobile ? source.getAttribute('data-turn') : img.getAttribute('data-turn');
      var next = new Image();
      next.onload = function () {
        if (source) source.srcset = source.getAttribute('data-turn');
        img.src = img.getAttribute('data-turn');
      };
      next.src = url;
    };
    var later = function () { whenIdle(startTurn); };
    if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
  }

  /* ------------------------------------------------------------------
     Drop countdown on the password page: days, hours, minutes until the
     drop date from the theme setting. Hidden again once the time is up.
     ------------------------------------------------------------------ */
  var countdown = document.querySelector('[data-drop-countdown]');
  if (countdown) {
    var dropAt = parseInt(countdown.getAttribute('data-drop-epoch'), 10) * 1000;
    var tick = function () {
      var left = dropAt - Date.now();
      if (!(left > 0)) { countdown.hidden = true; return; }
      var m = Math.floor(left / 60000);
      countdown.textContent = countdown.getAttribute('data-text')
        .replace('[d]', Math.floor(m / 1440)).replace('[h]', Math.floor(m / 60) % 24).replace('[m]', m % 60);
      countdown.hidden = false;
    };
    tick();
    window.setInterval(tick, 30000);
  }

  /* ------------------------------------------------------------------
     Language switcher (DE | EN).

     A click submits Shopify's localization form, so Shopify itself keeps
     the choice, and the choice is stored here too — the early script in
     <head> (snippets/language-redirect.liquid) reads it on every page and
     never overrides it.
     ------------------------------------------------------------------ */
  var LANG_KEY = 'bacto_lang';
  var saveLang = function (code) { try { localStorage.setItem(LANG_KEY, code); } catch (e) {} };

  Array.prototype.forEach.call(document.querySelectorAll('[data-localization]'), function (root) {
    var form = root.querySelector('form');
    var input = root.querySelector('[data-localization-input]');
    if (!form || !input) return;

    var go = function (code) {
      input.value = code;
      form.submit();
    };

    Array.prototype.forEach.call(root.querySelectorAll('[data-locale]'), function (link) {
      link.addEventListener('click', function (e) {
        var code = link.getAttribute('data-locale');
        saveLang(code);
        if (code === root.getAttribute('data-current')) { e.preventDefault(); return; }
        e.preventDefault();
        go(code);
      });
    });
  });


  /* ------------------------------------------------------------------
     Dialog wiring, with a fallback for browsers without <dialog>.
     ------------------------------------------------------------------ */
  var dlg = document.getElementById('WiderrufDialog');
  if (dlg) {
    var supportsDialog = typeof dlg.showModal === 'function';

    var openDialog = function () {
      if (supportsDialog) dlg.showModal();
      else { dlg.setAttribute('open', ''); dlg.classList.add('wdialog--fallback'); }
      var first = dlg.querySelector('input, button');
      if (first) first.focus();
    };
    var closeDialog = function () {
      if (supportsDialog) dlg.close();
      else { dlg.removeAttribute('open'); dlg.classList.remove('wdialog--fallback'); }
    };

    Array.prototype.forEach.call(document.querySelectorAll('[data-widerruf-open]'), function (btn) {
      btn.addEventListener('click', openDialog);
    });
    Array.prototype.forEach.call(dlg.querySelectorAll('[data-widerruf-close]'), function (btn) {
      btn.addEventListener('click', closeDialog);
    });

    /* Click on the backdrop closes it. */
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) closeDialog();
    });

    /* Shopify bounces back to the page after submitting — reopen so the
       customer actually sees the confirmation. */
    if (dlg.querySelector('[data-widerruf-success]') ||
        /[?&]contact_posted=true/.test(window.location.search)) {
      openDialog();
    }
  }

  /* ------------------------------------------------------------------
     Size table: show "← wischen →" only while the table is wider than
     its box. Measured when the panel opens and when the width changes.
     ------------------------------------------------------------------ */
  (function () {
    var tables = document.querySelectorAll('[data-size-table]');
    if (!tables.length) return;
    var mark = function () {
      Array.prototype.forEach.call(tables, function (box) {
        if (!box.offsetWidth) return;
        if (box.scrollWidth > box.clientWidth + 1) box.setAttribute('data-scrollable', '');
        else box.removeAttribute('data-scrollable');
      });
    };
    Array.prototype.forEach.call(tables, function (box) {
      var details = box.closest('details');
      if (details) details.addEventListener('toggle', mark);
    });
    window.addEventListener('resize', mark);
    mark();
  })();

  /* ------------------------------------------------------------------
     Home split slider (phones). Each image + product pair scrolls sideways
     with native scroll snap (CSS). Here: the dots follow the scroll and
     move the track when tapped, and — only while the phone layout is on —
     the track is a labelled region you can focus and move with the arrow
     keys, each slide labelled "Bild 1 von 2". On wider screens the
     wrappers are display: contents and carry no roles.
     ------------------------------------------------------------------ */
  (function () {
    var pairs = document.querySelectorAll('[data-split-pair]');
    if (!pairs.length || !window.matchMedia) return;
    var phone = window.matchMedia('(max-width: 749px)');
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

    Array.prototype.forEach.call(pairs, function (pair) {
      var track = pair.querySelector('[data-split-track]');
      var slides = track ? track.querySelectorAll('[data-split-slide]') : [];
      var dots = pair.querySelectorAll('[data-split-dot]');
      if (!track || slides.length < 2) return;

      var current = function () {
        var max = track.scrollWidth - track.clientWidth;
        return max > 0 ? Math.round((track.scrollLeft / max) * (slides.length - 1)) : 0;
      };
      var mark = function () {
        var i = current();
        Array.prototype.forEach.call(dots, function (dot, n) {
          if (n === i) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      };
      var go = function (i) {
        var max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: (max * i) / (slides.length - 1), behavior: calm.matches ? 'auto' : 'smooth' });
      };
      var roles = function () {
        if (phone.matches) {
          track.setAttribute('role', 'region');
          track.setAttribute('aria-label', track.getAttribute('data-label') || '');
          track.setAttribute('tabindex', '0');
          Array.prototype.forEach.call(slides, function (s) {
            var label = s.getAttribute('data-label') || '';
            if (s.tagName === 'A') {
              /* A link keeps its name: "Bild 2 von 2: Bacto Earth". */
              var name = s.querySelector('.product-tile__name');
              if (name) label += ': ' + name.textContent.trim();
            } else {
              s.setAttribute('role', 'group');
            }
            s.setAttribute('aria-label', label);
          });
        } else {
          ['role', 'aria-label', 'tabindex'].forEach(function (a) { track.removeAttribute(a); });
          Array.prototype.forEach.call(slides, function (s) {
            s.removeAttribute('role');
            s.removeAttribute('aria-label');
          });
        }
      };

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; mark(); });
      }, { passive: true });
      Array.prototype.forEach.call(dots, function (dot) {
        dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-split-dot'), 10) || 0); });
      });
      if (phone.addEventListener) phone.addEventListener('change', roles);
      roles();
      mark();
    });
  })();
})();
